import { RootState } from 'store/rootReducer';

export const detectMarketSlice = (state: RootState) => state.features.detectMarket;

export const getSelectedMarket = (state: RootState) => detectMarketSlice(state).selectedMarket.market;

export const detectMarketState = (state: RootState) => detectMarketSlice(state).detectMarket;
